import React, { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import { Spinner } from "react-bootstrap";

const SingleBlog = () => {
  const { slug } = useParams();
  const [page, setPage] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    setLoading(true);

    fetch(
      `https://public-api.wordpress.com/wp/v2/sites/smafathersorg.wordpress.com/pages?slug=${slug}`
    )
      .then((res) => res.json())
      .then((data) => {
        if (data && data.length > 0) {
          setPage(data[0]);
        } else {
          setPage(null);
        }
        setLoading(false);
      })
      .catch((error) => {
        console.error("Error loading blog:", error);
        setLoading(false);
      });
  }, [slug]);

  if (loading) {
    return (
      <div className="text-center mt-5">
        <Spinner animation="border" />
      </div>
    );
  }

  if (!page) {
    return (
      <div className="container mt-5 text-center">
        <h4>Blog not found</h4>
      </div>
    );
  }

  return (
    <div className="container mt-5 mb-5">
      <div className="row justify-content-center">
        <div className="col-lg-8 col-md-10">

          <h2
            className="mb-4"
            style={{ fontSize: "36px", fontWeight: "700", lineHeight: "1.3" }}
            dangerouslySetInnerHTML={{ __html: page.title.rendered }}
          />

          <div
            className="blog-content"
            style={{
              fontSize: "20px",
              lineHeight: "1.8",
              color: "#333"
            }}
            dangerouslySetInnerHTML={{
              __html: page.content.rendered,
            }}
          />

        </div>
      </div>
    </div>
  );
};

export default SingleBlog;